<template>
	<vs-row>
		<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" vs-lg="12">
		    <div class="text-left w-full">
	    		<vs-select autocomplete class="mt-5 w-full px-2" v-model="properties.default"  :label="$t('MODULE.typePassword')">
	    		    <vs-select-item :key="index" :value="item.value" :text="$t(`MODULE.${item.text}`)" v-for="(item, index) in opcionesDefault" />
	    		</vs-select>
	    	</div>
		 </vs-col>
		 <vs-col v-if="inputType === 'password'"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" vs-sm="12" vs-lg="12">
		     <div class="text-left w-full">
		     	<MinMax :properties="properties"></MinMax>
	     	</div>
		  </vs-col>
	</vs-row>
</template>

<script>
	// import OptionsDefault from './opcionesDefault.js';
	import OptionsDefault from '../../../componentsToQuestions/opcionesDefault.js';
	import MinMax from './Input.vue';
	export default {
		components: { MinMax },
		props: {
			properties: {
				type: Object,
				required: false,
				default: {}
			},
			inputType: {
				type: String,
				required: false,
				default: 'password'
			}
		},
		data() {
			return {
				...OptionsDefault,
			}
		},
		computed: {
			opcionesDefault() {
				if(this.type === 'geo') return this.Geo;
				if(this.inputType === 'phone') return this.Phone;
				if(this.inputType === 'radio') return this.Radio;
				if(this.inputType === 'password')  return this.Password;
				if(this.inputType === 'time') return this.Time;
				if(this.inputType === 'label' || this.inputType === 'section') return this.Fuentes;
				if(this.inputType === 'web' || this.inputType === 'document') return this.Viewer;
				if(this.inputType === 'paragraph') return this.Paragraph;
			}

		}


	}
</script>
